import styled from 'styled-components';

import HoverIcon from 'components/HoverIcon';
import { whitesmoke } from 'utils/style/colors';

export const QuestionFields = styled('div')`
  margin: 1rem 0;
`;

export const FieldBox = styled('div')`
  margin: 1rem 0;
  display: flex;
  padding: 0.5rem 1rem;
  flex-direction: column;
  background: ${whitesmoke};
  border-radius: 10px;
`;

export const Delete = styled(HoverIcon)`
  align-self: baseline;
`;

export const OptionListContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
`;
